module.exports = __webpack_public_path__ + "img/planet3.04af5d09.png";